// components/layout/BlitzPayTabs.jsx
import React from "react";
import {
  Tabs,
  Tab,
  Box,
  useMediaQuery,
  Divider,
} from "@mui/material";
import {
  ViewList as ViewListIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
} from "@mui/icons-material";
import { TabBadge } from "./styles";
import { useTheme, alpha } from '@mui/material/styles';

const BlitzPayTabs = ({ 
  tabIndex, 
  onTabChange, 
  totalIncomingAmount,
  isMobile = false,
}) => {
  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down("sm"));

  // Use icon-only on extra small screens, short labels on mobile, full labels on desktop
  const getTabLabel = (icon, shortLabel, fullLabel, badge = null) => {
    if (isExtraSmall) {
      return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: 'relative' }}>
          {icon}
          {badge}
        </Box>
      );
    } else if (isMobile) {
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, position: 'relative' }}>
          {icon}
          <Box component="span" sx={{ fontSize: '0.875rem' }}>{shortLabel}</Box>
          {badge}
        </Box>
      );
    } else {
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, position: 'relative' }}>
          {icon}
          {fullLabel}
          {badge}
        </Box>
      );
    }
  };

  return (
    <Box>
      <Tabs
        value={tabIndex}
        onChange={onTabChange}
        variant={isMobile ? "fullWidth" : "fullWidth"}
        sx={{
          px: 3,
          pt: 1,
          minHeight: isMobile ? 48 : 56,
          bgcolor: 'transparent',
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            fontSize: isMobile ? "0.875rem" : "0.95rem",
            py: isMobile ? 1.5 : 2,
            minHeight: isMobile ? 48 : 56,
            px: isMobile ? (isExtraSmall ? 1.5 : 2) : 3,
            color: 'text.secondary',
            transition: 'all 0.2s',
            '&.Mui-selected': {
              color: 'primary.main',
            },
            '&:hover': {
              color: 'primary.main',
              bgcolor: alpha(theme.palette.primary.main, 0.04),
            }
          },
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: '3px 3px 0 0',
          },
        }}
      >
        <Tab 
          label={getTabLabel(
            <ViewListIcon sx={{ fontSize: isExtraSmall ? 20 : 22 }} />,
            "All",
            "All Activity"
          )}
          aria-label="All Activity"
        />
        <Tab 
          label={getTabLabel(
            <ReceiptIcon sx={{ fontSize: isExtraSmall ? 20 : 22 }} />,
            "Invoices",
            "Invoices",
            totalIncomingAmount > 0 && (
              <TabBadge 
                badgeContent={totalIncomingAmount} 
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: isExtraSmall ? '0.625rem' : '0.7rem',
                    minWidth: isExtraSmall ? 16 : 18,
                    height: isExtraSmall ? 16 : 18,
                  }
                }}
              />
            )
          )}
          aria-label="Invoices"
        />
        <Tab
          label={getTabLabel(
            <PaymentIcon sx={{ fontSize: isExtraSmall ? 20 : 22 }} />,
            "Payouts",
            "Payouts"
          )}
          aria-label="Payouts"
        />
      </Tabs>
      
      {/* Divider below tabs */}
      <Divider />
    </Box>
  );
};

export default BlitzPayTabs;